// Centralized API configuration
// This ensures all API calls use the same base URL
// Note: /api is included in the base URL for API calls
// BASE_URL is for media files (without /api)
const BASE_URL_WITHOUT_API = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '').replace(/\/$/, '') // Remove /api if present
  : 'https://www.gfmstudio.com';

export const BASE_URL = BASE_URL_WITHOUT_API;
// API_BASE_URL must end with /api for correct routing
const rawApiUrl = process.env.REACT_APP_API_URL || 'https://www.gfmstudio.com/api';
export const API_BASE_URL = rawApiUrl.replace(/\/api\/?$/, '') + '/api';

// Contact page data is fetched from Django admin via /content/contact-page/ API

